import {Component, OnInit} from '@angular/core';
import {ICartImage} from "../../cart/catalog/catalog-models";
import {LoggerService} from "../../common/logger.service";
import {IMPCheckerboardModule, IMPDurations} from "../marketing-page.models";
import {CartUtil} from "../../cart/cart-util";
import {Constants} from "../../constants";
import {MarketingPageUtil} from "../marketing-page-util";
import {UsanaObject} from "../../usana-object";
import {UserService} from "../../common/user.service";
import {IShopUser} from "../../session/customer-models";

@Component({
    templateUrl: './checkerboard.component.html',
    styleUrls: ['./checkerboard.component.scss'],
    standalone: false
})
export class CheckerboardComponent extends UsanaObject implements OnInit {

    pageUrl: string;
    componentData: IMPCheckerboardModule;
    useLocaleOverride: boolean;
    translationRoot: string;
    mobileImagePath: string;
    imageAlignment: string;
    buttonType: string;
    backgroundColor: string;
    textStyle: string;
    callToActionUrl: string;
    violatorBackgroundColor: string;
    violatorTextStyle: string;
    hasViolator: boolean;
    applicationStart: Date;
    hasDuration: boolean;
    isExpired: boolean = false;
    cartImages: ICartImage[];

    constructor(
        loggerService: LoggerService,
        private userService: UserService,
    ) {
        super(
            loggerService
        );
    }

    ngOnInit() {
        if (this.componentData?.durations?.length > 0 && this.componentData?.durations?.[0].type == Constants.MARKETING_PAGE_GUIDED_ENROLL_TYPE) {
            this.hasDuration = true;
            this.userService.getShopUser().subscribe((user: IShopUser) => {
                this.applicationStart = new Date(user.customer.applicationDate);
                this.isExpired = this.checkExpiration(this.applicationStart, this.componentData.durations[0]);
                if (!this.isExpired) {
                    this.setComponentData();
                    this.initViolator();
                }
            });
        } else {
            this.setComponentData();
            this.initViolator();
        }
    }

    checkExpiration(applicationStart: Date, duration: IMPDurations): boolean {
        const now = new Date();
        const durationDays = duration.days || 0;
        const durationHours = duration.hours || 0;

        const endDate = new Date(
            applicationStart.getTime() +
            (durationDays * 24 * 60 * 60 * 1000) +
            (durationHours * 60 * 60 * 1000)
        );

        return endDate.getTime() < now.getTime();
    }

    setComponentData() {
        this.translationRoot = MarketingPageUtil.getTranslationRoot(this.pageUrl, this.componentData.name);
        this.cartImages = MarketingPageUtil.getCartImagesFromModule(this.componentData);
        this.mobileImagePath = CartUtil.getCartImagePathByType(this.cartImages, Constants.IMAGE_TYPE_MOBILE);
        this.imageAlignment = MarketingPageUtil.getImageAlignmentCLass(this.componentData.contentAlignment);
        this.buttonType = MarketingPageUtil.getButtonTypeClass(this.componentData.buttonType);
        this.backgroundColor = MarketingPageUtil.getBackgroundColor(this.componentData.backgroundColor);
        this.textStyle = MarketingPageUtil.getTextStyleClass(this.componentData.textStyle);
        this.callToActionUrl = this.componentData.countryDetails[0].callToActionUrl;

    }

    callToActionClick() {
        window.location.href = this.callToActionUrl;
    }

    initViolator() {
        if (this.componentData.includeViolator) {
            this.hasViolator = true;
            this.violatorBackgroundColor = MarketingPageUtil.getBackgroundColor(this.componentData.violatorBackgroundColor);
            this.violatorTextStyle = MarketingPageUtil.getTextStyleClass(this.componentData.violatorTextStyle);
        }
    }
}
